import { DotLottie } from '@lottiefiles/dotlottie-web';
import React, { useCallback, useEffect, useRef } from 'react';

import FruitfulThinking from '../../../../assets/animations/fruitful-thinking.json';

/** Final frame of fruitful-thinking.json — static leaf/seed logo after outro. */
const FRUITFUL_THINKING_LOGO_FRAME = Math.floor(FruitfulThinking.op);

const ANIM_DATA = FruitfulThinking as Record<string, unknown>;

export const StaticFruitfulIcon = () => {
    const dotLottieRef = useRef<DotLottie | null>(null);

    const setCanvasRef = useCallback((node: HTMLCanvasElement | null) => {
        if (dotLottieRef.current) {
            dotLottieRef.current.destroy();
            dotLottieRef.current = null;
        }

        if (!node) return;

        const instance = new DotLottie({
            canvas: node,
            data: ANIM_DATA,
            autoplay: false,
            loop: false,
        });
        dotLottieRef.current = instance;

        const showLogoFrame = () => {
            if (!dotLottieRef.current?.isLoaded) {
                requestAnimationFrame(showLogoFrame);
                return;
            }

            dotLottieRef.current.setFrame(FRUITFUL_THINKING_LOGO_FRAME);
        };

        requestAnimationFrame(showLogoFrame);
    }, []);

    useEffect(() => {
        return () => {
            dotLottieRef.current?.destroy();
            dotLottieRef.current = null;
        };
    }, []);

    return (
        <div style={{ width: 40, height: 40 }}>
            <canvas
                ref={setCanvasRef}
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};
